import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['QaTabHeaderStyles-cvaRoot', 'max-w-[37rem]']);

export const cvaTitle = cva(['QaTabHeaderStyles-cvaTitle', 'mb-3.2', 'text-h3 font-secondary']);

export const cvaButton = cva(['QaTabHeaderStyles-cvaButton', 'px-3.2', 'text-[1.6rem] font-semibold']);
